import http from '~/common/http'

export const Model = {
    customer_id: 0,   //客户id
    prefix: "",        //用户名前缀
    uid: 0,           //用户id
    username: "",      //用户名
    realname: "",      //真实姓名
    identity: "",      //身份
    is_admin: 0,      //是否管理员
    group_id: 0,       //用户组id
    groupName: '',     //用户名
    originPwd: '',      //初始密码
    fixPwd: '',           //修改后密码
    typeSelect: ''       //添加账号 用户名 UID选择
};

const TYPE_ALL = 0;     //全部
const TYPE_TEACHER = 1; //教师
const TYPE_STUDENT = 2; //学生
const TYPE_PARENT = 3; //家长

const STATUS_USER = 0; //否
const STATUS_ADMIN = 1; //是管理员

const FILTER_ALL = 0;       //全部
const FILTER_ID = 1;        //uid
const FILTER_USERNAME = 2;  //用户名
const FILTER_REALNAME = 3;  //真实姓名

export default {

    // 得到账号模型实例
    getModel() {
        return Model;
    },

    // 得到身份类型枚举
    getIndentify() {
        return {
            '0': '请选择',
            [TYPE_TEACHER]: '教师',
            //[TYPE_STUDENT]: '学生',
            //[TYPE_PARENT]: '家长'
        }
    },

    //得到账号属性
    getProperties() {
        return {
            0: '私有',
            1: '公有'
        }
    },

    // 得到管理员状态枚举
    getStatus() {
        return {
            [STATUS_ADMIN]: '是',
            [STATUS_USER]: '否'
        }
    },

    // 得到高级筛选枚举
    getFilter() {
        return {
            [FILTER_ALL]: '全部',
            [FILTER_ID]: 'UID',
            [FILTER_USERNAME]: '用户名',
            [FILTER_REALNAME]: '真实姓名'
        }
    },

    // 添加账号筛选
    getAdmin() {
        return {
            [FILTER_ID]: 'UID',
            [FILTER_USERNAME]: '用户名'
        }
    },

    // 密码重置
    resetPassword(user) {
        return http.put('/api/customer-accounts/reset-password?uid=' + user.uid, user);
    },

    //重置密码并发送短信
    resetPasswordSms(user){
        return http.put('/api/customer/accounts/reset-password-sms?uid=' + user.user_id, user);
    },

    // 批量设置为普通用户
    batchSetUser(user) {
        return http.put('/api/customer-accounts/batch-set-user?uid=' + user.uid, user);
    },

    // 批量设置为管理员
    // batchSetAdmin(user) {
    //     return http.put('/api/customer-accounts/batch-set-admin?uid=' + user.uid, user);
    // },

    // 添加已存在的账号
    create(user) {
        return http.post('/api/customer-accounts/create', user);
    },

    //批量设置用户组
    batchSetGroup(user) {
        return http.put('/api/customer-accounts/batch-set-group', user);
    },

    // 用户删除（单个及批量）
    delete(uids) {
        return http.delete('/api/customer-accounts/delete', {
            data: {
                uids: uids
            }
        })
    },

    // 用户删除（单个及批量）
    remove(uids) {
        return http.delete('/api/customer-accounts/remove', {
            data: {
                uids: uids
            }
        })
    },

    // 账号信息修改
    update(user) {
        return http.put('/api/customer-accounts/update?uid=' + user.uid, user);
    },

    // 账号批量注册
    batchCreate(user) {
        return http.post('/api/customer-accounts/batch-create', user);
    },

    //账号批量实名认证
    batchCrt(user) {
        return http.post('/api/customer-accounts/batch-crt', user);
    },
    // 账号筛选
    accountFilter(user) {
        return http.get('/api/customer/accounts/index', {
            params: user
        });
    },

    //获取用户组账号消费情况
    getConsumerData(params) {
        return http.get('/api/product/default/get-consumer-data', {
            params: params
        });
    },

    //直通车用户组
    ztcGroup(params) {
        return http.get('/api/common/get-ztc-group', {
            params: params
        })
    },

    // 新增用户组
    createGroup(group) {
        return http.post('/api/customer/groups/create', group);
    },

    //批量导出账号
    exportAccounts(customer_id) {
        return http.get('/api/customer-accounts/export', {
            params: {
                customer_id: customer_id
            }
        });
    },

    getGroups(params) {
        return http.get('/api/customer/groups/index', {
            params: params
        });
    },

    deleteGroup(group) {
        return http.delete('/api/customer/groups/delete', {
            params: {
                id: group.id,
                customer_id: group.customer_id
            }
        });
    },

    updateGroup(group) {
        return http.put('/api/customer/groups/update?id=' + group.id + '&customer_id=' + group.customer_id, group);
    },

    /**
     * 注册单个账号
     * @param account
     * @returns {*}
     */
    register(account) {
        return http.post('/api/customer/accounts/register', account);
    },

    /**
     * 批量注册账号
     * @param accounts
     * @returns {*}
     */
    batchRegister(accounts) {
        return http.post('/api/customer/accounts/batch-register', accounts);
    },


    /**
     * 批量替换账号
     * @param accounts
     * @returns {*}
     */
    batchReplace(accounts) {
        return http.post('/api/customer/accounts/batch-replace', accounts);
    },

    /**
     * 获取账号列表
     * @param params
     * @returns {*}
     */
    getAccounts(params) {
        return http.get('/api/customer/accounts/index', {
            params: params
        });
    },

    /**
     * 产品账号激活
     * @param params
     * @returns {AxiosPromise<any>}
     */
    activeAccounts(params) {
        return http.post('/api/customer/accounts/active', params);
    },

    /**
     * 产品账号禁用
     * @param params
     */
    disable(params) {
        return http.post('/api/customer/accounts/disable', params);
    },

    /**
     * 得到产品服务列表
     * @returns {*}
     */
    getServices() {
        return http.get('/api/customer/accounts/services');
    },

    /**
     * 删除账号
     * @param customerId
     * @param accounts
     * @returns {*}
     */
    deleteAccount(params) {
        return http.post('/api/customer/accounts/delete', params);
    },

    /**
     * 更新账号信息
     * @param params
     * @returns {*}
     */
    updateAccount(params) {
        return http.put('/api/customer/accounts/update', params);
    },



    /**
     * 添加已有账号
     * @param params
     * @returns {*}
     */
    addExist(params) {
        return http.post('/api/customer/accounts/add', params);
    },

    /**
     * 批量实名认证
     * @param accounts
     * @returns {*}
     */
    batchRealAuth(accounts) {
        return http.post('/api/customer/accounts/batch-real-auth', accounts);
    },

    /**
     * 批量获取账号详情
     * @param accounts
     * @returns {*}
     */
    getDetails(accounts) {
        return http.post('/api/customer/accounts/details', accounts);
    },

    /**
     * 将账号同步至数字化校园
     * @param accounts
     * @returns {*}
     */
    syncSzxy(accounts) {
        return http.post('/api/customer/accounts/sync', accounts);
    },

    /**
     * 批量重置账号密码
     * @param params
     * @returns {*}
     */
    batchResetPassword(params) {
        return http.post('/api/customer/accounts/batch-reset-password', params);
    },

    setRandomPassword(params) {
        return http.post('/api/customer/accounts/set-random-password', params);
    },

    /**
     * 得到预览信息
     * @param params
     * @returns {*}
     */
    getPreview(params) {
        return http.post('/api/customer/accounts/preview', params);
    },

    /**
     * 批量设置账号为管理员
     * @param params
     * @returns {*}
     */
    batchSetAdmin(params) {
        return http.post('/api/customer/accounts/batch-set-admin', params);
    },

    /**
     * 解绑账号手机
     * @param params
     */
    unbind(params) {
        return http.post('/api/customer/accounts/unbind', params);
    },

    /**
     * 解绑微信qq邮箱
     * @param params
     */
    unbindWechatQQEmail(params) {
        return http.post('/api/customer/accounts/unbound-wechat-qq-email', params);
    },

    /**
     * 检查手机是否已经注册账号
     * @param params
     * @returns {AxiosPromise<any>}
     */
    checkExists(params) {
        return http.post('/api/customer/accounts/check-exists', params);
    },

    getChangeLogs(params) {
        return http.get('/api/customer/accounts/change-log', {
            params: params
        });
    },

    getInfo(params) {
        return http.get('/api/customer/accounts/view', {
            params: params
        });
    },

    getMemberList(params) {
        return http.get('/api/customer/accounts/member-list', {
            params: params
        });
    },

    //批量设置公有账号
    batchSetPublicAccount(params)
    {
        return http.post('/api/customer/accounts/batch-set-public-account',params );
    },
    //撤销已授权设备
    deleteUserDeviceId(params)
    {
        if(params['type'] == 1) {
            return http.get('/api/customer/accounts/delete-user-device-id?uid='+params['uid']+'&type=1' );
        }else{
            return http.get('/api/customer/accounts/delete-user-device-id?uid='+params['uid'] );
        }

    },

    //撤销已授权设备
    unblockLogin(params)
    {
        return http.get('/api/customer/accounts/unblock-login?username='+params['username'] );
    },

    //迁移排课旧数据
    migrateOlddata(customer_id,old_school_id)
    {
        return http.get('/api/customer/accounts/migrate-olddata?schoolId='+customer_id+'&oldSchoolId='+old_school_id);
    },
    //排课旧数据方案
    getSolutions(params)
    {
        return http.get('/api/product/default/get-solutions?schoolId='+params['schoolId']);
    },
    //排课旧数据方案
    syncTime(schoolId)
    {
        return http.get('/api/product/default/sync-time?schoolId='+schoolId);
    },

    // 数字化校园模拟登录
    szxyQuickLogin(params) {
        return http.get('/api/customer/accounts/szxy-quick-login', {
            params: params
        });
    },

    /**
     * 获取登录日志列表
     * @param params
     * @returns {AxiosPromise<any>}
     */
    getLoginLog(params){
        return http.get('api/product/default/get-login-log',{
            params: params
        })
    },
}



// WEBPACK FOOTER //
// ./src/services/CustomerAccounts.js